import request from '@/utils/request'

function unwrapPage(res) {
  if (res && res.code && res.code !== 2000) {
    return Promise.reject(new Error(res.message || '请求失败'))
  }
  const page = (res && res.items) || res || {}
  return {
    records: page.Data || page.data || page.records || [],
    total: page.totalCount != null ? page.totalCount : (page.total || 0)
  }
}

function unwrapData(res) {
  if (res && res.code && res.code !== 2000) {
    return Promise.reject(new Error(res.message || '请求失败'))
  }
  return (res && res.items) != null ? res.items : res
}

export function fetchExhibitionList(params) {
  return request({
    url: '/pc/exhibition/list',
    method: 'get',
    params
  }).then(unwrapPage)
}

export function fetchExhibitionCategories() {
  return request({
    url: '/pc/exhibition/categories',
    method: 'get'
  }).then(unwrapData)
}

export function fetchExhibitionDetail(id) {
  return request({
    url: '/pc/exhibition/detail',
    method: 'get',
    params: { id }
  }).then(unwrapData)
}

export function mapExhibitionItem(item) {
  return {
    id: item.id,
    title: item.title || '',
    description: item.description || '',
    image: item.coverUrl && item.coverUrl.url ? item.coverUrl.url : '',
    categoryId: item.categoryId,
    categoryName: item.categoryName || ''
  }
}

export function mediaUrl(media) {
  if (!media) return ''
  return media.url || ''
}

const ENTITY_ROUTE_TYPES = ['renwu', 'jigou', 'didian', 'shijian']

const SOURCE_TYPE_ROUTE_MAP = {
  1: 'renwu',
  2: 'shijian'
}

function normalizeEntityRouteType(code, sourceType) {
  const value = String(code || '').trim().toLowerCase()
  if (ENTITY_ROUTE_TYPES.includes(value)) {
    return value
  }
  if (SOURCE_TYPE_ROUTE_MAP[sourceType]) {
    return SOURCE_TYPE_ROUTE_MAP[sourceType]
  }
  return 'renwu'
}

export function resolveExhibitionItemPath(item) {
  if (!item) return ''

  const contentType = item.contentType
  if (contentType === 0 && item.sourceId) {
    return `/resources/${item.sourceId}`
  }
  if (contentType === 1 && item.sourceId) {
    const entityType = normalizeEntityRouteType(item.entityType, item.sourceType)
    return `/knowledge/${entityType}/${item.sourceId}`
  }
  if (item.link) {
    return String(item.link).trim()
  }
  return ''
}

export function stripExhibitionItemText(value) {
  if (!value) return ''
  return String(value)
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<[^>]+>/g, '')
    .replace(/\s+/g, ' ')
    .trim()
}

export function parseExhibitionItemAttributes(item) {
  if (!item) return []
  if (Array.isArray(item.attributes) && item.attributes.length) {
    return item.attributes
      .map((attr) => ({
        label: attr.label || '',
        value: stripExhibitionItemText(attr.value)
      }))
      .filter((attr) => attr.label && attr.value)
  }
  const seen = new Set()
  const attrs = []
  const parts = String(item.description || '').split(/<br\s*\/?>/gi)
  parts.forEach((part) => {
    const text = stripExhibitionItemText(part)
    if (!text) return
    const separatorIndex = text.indexOf(':')
    if (separatorIndex <= 0) return
    const label = text.slice(0, separatorIndex).trim()
    const value = text.slice(separatorIndex + 1).trim()
    if (!label || !value || value === '-') return
    const key = label.toLowerCase()
    if (seen.has(key)) return
    seen.add(key)
    attrs.push({ label, value })
  })
  return attrs
}
